﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadBlockField, ICadParameterField} from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadBlockField, eOutputFieldType.cadBlock)
export class CadBlockField extends OutputField implements ICadBlockField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public filePath: string;
    public flipX: boolean;
    public flipY: boolean;
    public insertionPointX: number;
    public insertionPointY: number;
    public insertionPointZ: number;
    public layer: string;
    public parameters: ICadParameterField[];
    public password: string;
    public rotation: number;
    public xScale: number;
    public yScale: number;
    public zScale: number;
}
